

import React from 'react';
import Demo from './components/Demo';
import Login from './components/Login';
import EmbedViewer from './components/EmbedViewer';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainContent from './components/MainContent';
import Users from './components/Users';
import HeatmapsAnalysis from './components/HeatmapsAnalysis';
import EngagementAnalytics from './components/EngagementAnalytics';
import BehaviorMetricsDashboard from './components/BehaviorMetricsDashboard';
import InteractionMetrics from './components/InteractionMetrics';
import './App.css';

// Route protection component
const ProtectedRoute = ({ element }) => {
  const accessToken = localStorage.getItem('accessToken');
  return accessToken ? element : <Navigate to="/login" replace />;
};

function App() {
  return (
    <div>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/embed" element={<EmbedViewer />} />
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Protected dashboard routes */}
          <Route 
            path="/dashboard" 
            element={<ProtectedRoute element={<Demo />} />}
          >
            <Route path="library" element={<MainContent />} />
            <Route path="users" element={<Users />} />
            <Route path="analytics" element={<HeatmapsAnalysis />} />
            <Route path="engagement" element={<EngagementAnalytics />} />
            <Route path="behavior-metrics" element={<BehaviorMetricsDashboard />} />
            <Route path="interaction-metrics" element={<InteractionMetrics />} />
            <Route index element={<MainContent />} />
          </Route>

          {/* Redirects */}
          <Route 
            path="/library" 
            element={
              <ProtectedRoute element={<Navigate to="/dashboard/library" replace />} />
            } 
          />
          <Route 
            path="/users" 
            element={
              <ProtectedRoute element={<Navigate to="/dashboard/users" replace />} />
            } 
          />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

